import { ApiConfig } from "../services/api-config"
import { ProcessorMetadata } from "../types/types"
import { UrlUtils } from "./url.utils"

export namespace ProcessorMetadataUtils {

    export function getUploadEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.uploadDomain) return null;
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.uploadDomain)}${metadata.uploadEndpoint}`
    } 
    export function getProcessorEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.processDomain) return null;
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.processDomain)}${metadata.processorEndpoint}`
    } 
    export function getUploadedFileDownloadEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.uploadDomain) return null;
        if(metadata.uploadDomain.indexOf('googleapis') !== -1) {
            return `${metadata.uploadDomain}${metadata.uploadedFileDownloadEndpoint}`
        }
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.uploadDomain)}${metadata.uploadedFileDownloadEndpoint}`
    }

    /**
     * The uploaded-file download endpoint as a URL an ironman EDGE can open — for the wire field
     * `fileUploadedServerEndpointList` (`file-process.service.ts`), which the processing edge uses to
     * pull the input off the edge that holds it (`ConvertService.downloadUploadedFilesToLocalDisk`).
     *
     * `getUploadedFileDownloadEndpoint` above is for THIS browser and follows `ApiConfig.originForDomain`:
     * behind the dev proxy (`services/dev-proxy.ts`) that is the same-origin path `/__xcdev/h/<host>/v2/edge/…`,
     * which only the browser can resolve. Sent to the server it made every cross-edge job fail with
     * `MalformedURLException: no protocol` while same-edge jobs passed (R14-SRV4, QA 2026-09-23: 26 of
     * 43 dev-proxy workflows). This form is always absolute `https://<host>/v2/edge…` — what a deployed
     * page sends; the googleapis case is unchanged because that domain is already absolute.
     */
    export function getUploadedFileDownloadEndpointForServer(metadata: ProcessorMetadata): string | null {
        if (!metadata?.uploadDomain) return null;
        if (metadata.uploadDomain.indexOf('googleapis') !== -1) {
            return `${metadata.uploadDomain}${metadata.uploadedFileDownloadEndpoint}`;
        }
        return `${UrlUtils.toHttpsProtocol(metadata.uploadDomain)}${ApiConfig.edgePathPrefix}${metadata.uploadedFileDownloadEndpoint}`;
    } 
    export function getDownloadEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.downloadDomain) return null;
        if(metadata.downloadDomain.indexOf('googleapis') !== -1) {
            return `${metadata.downloadDomain}${metadata.downloadEndpoint}`
        }
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.downloadDomain)}${metadata.downloadEndpoint}`
    } 
    export function getGcpTempDownloadEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.downloadDomain) return null;
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.downloadDomain)}${metadata.gcpTempDownloadEndpoint}`
    } 
    export function getEmailDownloadEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.downloadDomain) return null;
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.downloadDomain)}${metadata.emailDownloadEndpoint}`
    } 
    export function getImageShareEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.processDomain) return null;
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.processDomain)}${metadata.imageShareEndpoint}`
    } 
    export function getThumbnailEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.thumbnailDomain) return null;
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.thumbnailDomain)}${metadata.thumbnailEndpoint}`
    } 
    export function getUploadCommEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.uploadDomain) return null;
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.uploadDomain)}${metadata.commEndpoint}`
    } 
    export function getProcessCommEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.processDomain) return null;
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.processDomain)}${metadata.commEndpoint}`
    } 
    export function getZipEndpoint(metadata: ProcessorMetadata): string | null {
        if (!metadata?.processDomain) return null;
        return `${ApiConfig.suffixDomainWithHttpsEdgeEndpoint(metadata.processDomain)}${metadata.zipEndpoint}`
    } 
}
